import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

var Keyframe = /*#__PURE__*/function () {
  function Keyframe(name, style) {
    _classCallCheck(this, Keyframe);

    _defineProperty(this, "name", void 0);

    _defineProperty(this, "style", void 0);

    _defineProperty(this, "_keyframe", true);

    this.name = name;
    this.style = style;
  }

  _createClass(Keyframe, [{
    key: "getName",
    value: function getName() {
      var hashId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return hashId ? "".concat(hashId, "-").concat(this.name) : this.name;
    }
  }]);

  return Keyframe;
}();

export default Keyframe;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ant-design/cssinjs/es/Keyframes.js
// module id = 2341
// module chunks = 0